import { Injectable } from '@angular/core';
import { Observer } from './observer';
import { LocalInputManager } from './local-input-manager.service';
import { Message, NewDeviceMsg, NewEventsMsg, RemoveDeviceMsg, ChangeUsageMsg } from '../models/messages';
import { InputDeviceChange } from '../models/input-device-change.enum';

@Injectable({
  providedIn: 'root',
})
export class InputRemoting {
  private _localManager: LocalInputManager;
  private _subscribers: Array<Observer> = [];
  private _sending = false;

  constructor(localManager: LocalInputManager) {
    this._localManager = localManager;
  }

  startSending() {
    if (this._sending) {
      return;
    }
    this._sending = true;

    const onEvent = (e: any) => {
      this._sendEvent(e.detail.event);
    };

    const onDeviceChange = (e: any) => {
      this._sendDeviceChange(e.detail.device, e.detail.change);
    };

    this._localManager.setStartTime(Date.now() / 1000);
    this._localManager.onEvent.subscribe(onEvent);
    this._localManager.onEvent.subscribe(onDeviceChange);
    this._sendInitialMessages();
  }

  stopSending() {
    if (!this._sending) {
      return;
    }
    this._sending = false;
  }

  subscribe(observer: Observer) {
    this._subscribers.push(observer);
  }

  private _sendInitialMessages() {
    this._sendAllGeneratedLayouts();
    this._sendAllDevices();
  }

  private _sendAllGeneratedLayouts() {
    // todo:
  }

  private _sendAllDevices() {
    const devices = this._localManager.devices;
    if (devices == null) return;
    for (const device of devices) {
      this._sendDevice(device);
    }
  }

  private _sendDevice(device: any) {
    const newDeviceMessage = NewDeviceMsg.create(device);
    this._send(newDeviceMessage);
  }

  private _sendEvent(event: any) {
    const message = NewEventsMsg.create(event);
    this._send(message);
  }

  private _sendDeviceChange(device: any, change: InputDeviceChange) {
    let msg = null;
    switch (change) {
      case InputDeviceChange.Added:
        msg = NewDeviceMsg.create(device);
        break;
      case InputDeviceChange.Removed:
        msg = RemoveDeviceMsg.create(device);
        break;
      case InputDeviceChange.UsageChanged:
        msg = ChangeUsageMsg.create(device);
        break;
      default:
        return;
    }
    this._send(msg);
  }

  private _send(message: Message) {
    for (let subscriber of this._subscribers) {
      subscriber.onNext(message);
    }
  }
}
